/**
 * Created by Ning Jiang on 5/23/2018.
 */

import {
    ISymbolStateConfig,
    ISymbolStates,
    StateReelSymbol,
    SymbolStateTransition
} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {TimelineLite, TweenLite} from "gsap";
import {FruitsSymbolScale} from "../../config/FruitsSymbolScale";
import {FruitsGameConfig} from "../FruitsGameConfig";

export interface IFruitsSymbolStates extends ISymbolStates {
    readonly individualWin:ISymbolStateConfig;
    readonly land:ISymbolStateConfig;
    readonly respin:ISymbolStateConfig;
}

export class FruitsReelSymbol extends StateReelSymbol {

    private _winOverlay:PIXI.Container;
    private _winSprite:TimelineSprite;
    private _lineAnimationDuration:number = 0.4;

    constructor(symName:string, reelId:number, state?:ISymbolStateConfig) {
        super(symName, reelId, state);
    }

    protected reset(remove:boolean):void {
        super.reset(remove);

        if(this._winOverlay) {
            this._winOverlay.children.forEach(
                (sp) => {
                    (<TimelineSprite>sp).hide();
                }
            );
        }
    }

    protected initState(stateConfig:ISymbolStateConfig):boolean {
        if(super.initState(stateConfig)) {
            // To move the patches always on the top.
            if(this._winOverlay && this.symName !== "S" && this.symName !== "W" && this.symName !== "B1" && this.symName !== "B2") {
                this.addChild(this._winOverlay);
            }

            return true;
        }

        return false;
    }

    protected addNewStateAnimation(timeline:TimelineLite, transition:SymbolStateTransition, stateAnimation:TimelineSprite, delay:number):void {
        super.addNewStateAnimation(timeline, transition, stateAnimation, delay);

        if(transition.state.keyword === FruitsGameConfig.instance.SYMBOL_STATES.win.keyword && !this._winOverlay) {
            this.playWinOverlay()!.forEach(
                (tw) => {
                    timeline.add(tw, delay);
                }
            );
        }
        if(transition.state.keyword === FruitsGameConfig.instance.SYMBOL_STATES.individualWin.keyword) {
            this.playIndividualWinOverlay(timeline, delay);
        }
    }

    protected addOldStateAnimation(timeline:TimelineLite, transition:SymbolStateTransition, stateAnimation:TimelineSprite, delay:number):void {
        super.addOldStateAnimation(timeline, transition, stateAnimation, delay);

        if(transition.state.keyword != FruitsGameConfig.instance.SYMBOL_STATES.win.keyword && this._winOverlay) {
            this.hideWinOverlay()!.forEach(
                (tw) => {
                    timeline.add(tw, delay);
                }
            );
        }
        if(transition.state.keyword != FruitsGameConfig.instance.SYMBOL_STATES.individualWin.keyword && this._winOverlay) {
            this.hideWinOverlay();
            let tw:TweenLite = TweenLite.fromTo(this._winSprite, 0.01,
                {alpha : 0},
                {
                    alpha : 1,
                    onStart : () => {
                        this._winSprite.hide();
                    }
                });
            timeline.add(tw, delay);
        }
    }

    private initWinOverlay():void {
        if(this._winOverlay) {
            return;
        }

        this._winOverlay = new PIXI.Container();

        if(this.symName === "S") {
            this._winSprite = new TimelineSprite(GameResources.getTextures("S_win"));
            this._winOverlay.addChild(this._winSprite);
        } else {
            this._winSprite = new TimelineSprite(GameResources.getTextures(this.symName + "_win"));

            this._winSprite.scale.set(0.5, 0.5);


            this._winOverlay.addChild(this._winSprite);
        }

        let scale = FruitsSymbolScale.getScale(this.symName, "win");

        this._winSprite.scale.set(scale[0], scale[1]);
        this._winSprite.anchor.set(0.5, 0.5);
        this._winSprite.visible = false;
        this._winSprite.alpha = 0;

        this.addChild(this._winOverlay);
    }

    private playWinOverlay():TweenLite[] {
        this.initWinOverlay();

        let tweens:TweenLite[] = [];
        this._winOverlay.children.forEach(
            (sp) => {
                tweens.push(
                    TweenLite.fromTo(sp, 0.01,
                        {alpha : 0},
                        {
                            alpha : 1,
                            onStart : () => {
                                (<TimelineSprite>sp).show();
                                (<TimelineSprite>sp).getAnimation();
                            }
                        })
                );
            }
        );

        return tweens;
    }

    private hideWinOverlay():TweenLite[] | null {
        if(!this._winOverlay) {
            return null;
        }

        let tweens:TweenLite[] = [];
        this._winOverlay.children.forEach(
            (sp) => {
                tweens.push(
                    TweenLite.to(sp, 0.01, {
                        alpha : 0,
                        onComplete : () => {(<TimelineSprite>sp).hide();}
                    })
                );
            }
        );

        return tweens;
    }

    private playIndividualWinOverlay(timeline:TimelineLite, delay:number):void {
        this.initWinOverlay();
        let tw:TweenLite = TweenLite.fromTo(this._winSprite, 0.01,
            {alpha : 0},
            {
                alpha : 1,
                onStart : () => {
                    this._winSprite.show();
                    this._winSprite.getAnimation();
                }
            });
        timeline.add(tw, delay);
    }

    public dim(duration:number):void {
        TweenLite.to(this, duration, {alpha : 0.5});
    }

    public undim(duration:number):void {
        TweenLite.to(this, duration, {alpha : 1});
    }

}